import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';

import { DefaultService } from 'src/app/core/framework/default-service';
import { ErrorHandlerService } from 'src/app/core/framework/error-handler.service';
import { ChaveConfiguracao } from 'src/app/core/multi-tenancy/chave-configuracao.enum';
import { Parametro } from 'src/app/core/multi-tenancy/parametro.model';


@Injectable({
  providedIn: 'root'
})
export class ParametroService extends DefaultService<Parametro> {

  static url = '/api/integracao/v1/parametros';

  constructor(
    public httpClient: HttpClient,
    public errorHandler: ErrorHandlerService
  ) {
    super(
      httpClient,
      errorHandler,
      ParametroService.url
    )
  }

  buscar(chaveConfiguracao: ChaveConfiguracao, chaveParametro: string): Observable<Parametro> {
    return this.httpClient.get<Parametro>(`${ParametroService.url}/${chaveConfiguracao}/${chaveParametro}`)
                          .pipe(
                            catchError( err => {
                              if ( err.status === 404 ) {
                                return of(null);
                              }

                              return throwError(this.errorHandlerService.handle(err));
                            })
                          );
  }
}
